(() => {
  const config = document.getElementById('kaya-review-translations');
  const root = document.getElementById('judgeme_product_reviews');
  if (!config || !root) return;
  const labels = JSON.parse(config.textContent);
  const excluded = '.jdgm-rev__content, .jdgm-rev__author, .jdgm-rev__location, script, style';
  const translate = (value) => labels[value] || value.replace(/^Based on (\d+) reviews?$/, (_, count) => labels.__based.replace('__COUNT__', count)).replace(/^Average rating is ([\d.]+) stars$/, (_, count) => labels.__average.replace('__COUNT__', count)).replace(/^([\d.]+) star review$/, (_, count) => labels.__stars.replace('__COUNT__', count));
  const update = () => {
    observer.disconnect();
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: (node) => node.parentElement.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT });
    let node;
    while ((node = walker.nextNode())) {
      const source = node.nodeValue.trim();
      const target = translate(source);
      if (target !== source) node.nodeValue = node.nodeValue.replace(source, target);
    }
    root.querySelectorAll('[aria-label], img[alt], input[placeholder]').forEach((element) => {
      if (element.closest(excluded)) return;
      for (const attr of ['aria-label', 'alt', 'placeholder']) {
        const source = element.getAttribute(attr);
        if (source && translate(source) !== source) element.setAttribute(attr, translate(source));
      }
    });
    root.querySelectorAll('time[datetime]').forEach((element) => {
      const date = new Date(element.getAttribute('datetime'));
      if (!Number.isNaN(date.getTime())) element.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };
  const observer = new MutationObserver(update);
  update();
})();

